import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import shareLink from 'services/shareLink';

// Styles
import styles from './shareControls.scss';

/**
 * A component that contains share controls to share the current view via
 * Twitter, Facebook, LinkedIn, and email.
 */
export default class ShareControls extends React.PureComponent {
  /**
   * Renders the control based on the value of props.
   */
  render() {
    // Extract named properties from component props.
    const {
      dataView,
      geos,
      indicatorSubView,
      indicatorView,
      slug,
      timeframe,
      title,
    } = this.props;

    // Get the shareable link, provided the view props.
    const url = shareLink({
      dataView,
      geos,
      indicatorSubView,
      indicatorView,
      slug,
      timeframe,
    });

    // Negotiate scope label.
    const scope = 'usdata' === dataView ? 'US Data' : 'International Data';

    return (
      <ul className={styles.shareControls}>
        <li>
          <a
            href={`https://twitter.com/home?status=${scope}: ${title} via @PRBdata ${url}`}
          >
            Share on Twitter
          </a>
        </li>
        <li>
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          >
            Share on Facebook
          </a>
        </li>
        <li>
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${scope}: ${title} via @PRBdata`}
          >
            Share on LinkedIn
          </a>
        </li>
        <li>
          <a
            href={`mailto:someone@example.com?subject=${title} via prb.org&body=${scope}: ${title} via prb.org ${url}`}
          >
            Share via Email
          </a>
        </li>
      </ul>
    );
  }
}

ShareControls.propTypes = {
  dataView: PropTypes.string.isRequired,
  geos: PropTypes.arrayOf(PropTypes.string),
  indicatorSubView: PropTypes.string,
  indicatorView: PropTypes.string,
  slug: PropTypes.string.isRequired,
  timeframe: PropTypes.number,
  title: PropTypes.string.isRequired,
};

ShareControls.defaultProps = {
  geos: [],
  indicatorSubView: '',
  indicatorView: '',
  timeframe: -1,
};



// WEBPACK FOOTER //
// ./app/components/shareControls/index.js